import React, { Component } from 'react';
import { Modal, Spin, Button } from 'antd';
import TokenActionOrPlan from './TokenActionOrPlan';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';

class TokenActionOrPlanModal extends Component {
    state = {
        record: {},
        data: [],
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }
    
    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { record: { complaintRecordId } } = this.state;
        this.setState({ loading: true });
        Fetch.post(API_URL.qualityManagement.queryPlanByComplaintRecordId, {
            complaintRecordId,
        }).then(res => {
            this.setState({
                data: res.list,
                loading: false,
            });
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    render() {
        const { loading, visible, record, data } = this.state;
        const { complaintRecordNumber, investigationName } = record;
        return (
            <Modal
                title="已采取的措施或计划详情"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width="700px"
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading} style={{padding:'10px 20px 10px'}}>
                    <div>
                        投诉编号：{complaintRecordNumber}
                        <span className="ant-divider" />
                        项目简称：{investigationName}
                    </div>
                    <div style={{margin:'10px 0 10px'}}>
                        <TokenActionOrPlan
                            data={data}
                            canEdit={false}
                        />
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default TokenActionOrPlanModal;


// WEBPACK FOOTER //
// ./src/components/qualityManagement/ComplaintRegistrationForm/components/TokenActionOrPlanModal.js